module.exports = __webpack_public_path__ + "img/img-free-02.png";